import styled from 'styled-components';

export interface Props {
  width: string;
}

const DataTable = styled('table')<Props>`
  width: ${({ width }) => (width && width) || `100%`};
  table-layout: auto;
  margin: 0 auto;
  border-spacing: 0;
  color: ${({ theme }) => theme.color.white};
  th,
  td {
    padding: 0;
    &:first-child {
      text-transform: capitalize;
    }
  }
  thead tr th {
    ${({ theme }) => theme.typography.baseStrong}
    text-align: left;
  }
  tbody tr td {
    ${({ theme }) => theme.typography.tinyStrong};
    border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
    text-align: left;
    &:last-child {
      text-align: right;
    }
  }
`;

export default DataTable;
